if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.cart) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        // additional service on product page
        const productInfo = this.closest(".product__info-container");
        const sectionId = productInfo?.dataset.section;
        this.productAdditionalService = productInfo?.querySelector(
          `product-additional-service[data-section-id="${sectionId}"]`
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;

        //--------------------------------------------------
        // build a multi-item body if additional services OR a companion
        // auto-add (free SIM for this market, decided by companion-attrs) applies.
        // ordering: trigger product first, then services, then companion.
        let serviceOnlyItems = null;
        let extraServiceItems = [];
        let triggerItem = null;

        if (
          this.productAdditionalService &&
          this.productAdditionalService instanceof ProductAdditionalService &&
          typeof this.productAdditionalService.getItems === "function" &&
          Array.isArray(ProductAdditionalService.selectedServices) &&
          ProductAdditionalService.selectedServices.length > 0
        ) {
          const serviceItems = this.productAdditionalService.getItems(formData);
          if (serviceItems?.length > 0) {
            // serviceItems shape from getItems: [...services, mainItem]
            triggerItem = serviceItems[serviceItems.length - 1];
            extraServiceItems = serviceItems.slice(0, -1);
            serviceOnlyItems = serviceItems;
          }
        }

        // With a Mobile plan step on the page the customer's choice decides
        // (null = Phone only); otherwise companion-attrs' variant id, which it
        // only renders where a SIM applies.
        const productInfo = this.closest(".product__info-container");
        const chosenCompanion =
          window.BalanceMobile && productInfo
            ? window.BalanceMobile.companionFor(productInfo)
            : undefined;
        const companionVariantId =
          chosenCompanion !== undefined
            ? chosenCompanion
            : this.dataset.companionVariantId;
        const companionApplies = !!companionVariantId;
        const addonIds =
          window.BalanceMobile && productInfo
            ? window.BalanceMobile.addonsFor(productInfo)
            : [];
        const protectItem =
          window.BalanceMobile && window.BalanceMobile.protectFor && productInfo
            ? window.BalanceMobile.protectFor(productInfo)
            : null;
        if (protectItem) addonIds.push(protectItem);

        let items = [];

        if (companionApplies || addonIds.length > 0) {
          const triggerQuantity = parseInt(
            formData.get("quantity") || "1",
            10
          );
          if (!triggerItem) {
            triggerItem = {
              id: formData.get("id"),
              quantity: triggerQuantity,
            };
          }
          // trigger first → services (if any) → companion → add-ons
          items = [triggerItem, ...extraServiceItems];
          if (companionApplies) {
            items.push({ id: companionVariantId, quantity: triggerQuantity });
          }
          addonIds.forEach((addon) => items.push(addon));
        } else if (serviceOnlyItems) {
          // services path without companion — preserve existing behavior
          items = serviceOnlyItems;
        }

        if (items.length > 0) {
          const bodyData = { items };
          if (this.cart) {
            bodyData.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id);
            bodyData.sections_url = window.location.pathname;
          }

          delete config.headers["X-Requested-With"];
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(bodyData);
        }
        //--------------------------------------------------

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            // Brief "✓ Added" confirmation on the button. Skip inside the
            // quick-add modal (the button is hidden as the modal closes).
            if (!quickAddModal) this.showAddedFeedback();
            let activeElement = document.activeElement;
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.setActiveElement(activeElement);
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              if (
                this.productAdditionalService &&
                this.productAdditionalService instanceof
                  ProductAdditionalService &&
                typeof this.productAdditionalService.clearItems ===
                  "function" &&
                Array.isArray(ProductAdditionalService.selectedServices) &&
                ProductAdditionalService.selectedServices.length > 0
              ) {
                this.productAdditionalService.clearItems();
              }
            } else {
              if (this.closest(".header")) {
                const cartLink = document.querySelector("#cart-icon-bubble");
                if (cartLink) {
                  activeElement = cartLink;
                }
                activeElement = document.querySelector("#cart-icon-bubble");
              } else if (this.closest(".collection-product-card")) {
                const productCard = this.closest(".collection-product-card");
                const linkTitle = productCard.querySelector(".card__title > a");
                if (linkTitle) {
                  activeElement = linkTitle;
                }
              }

              this.cart.setActiveElement(activeElement);
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      showAddedFeedback() {
        const label = this.submitButton.querySelector(".button__label");
        if (!label) return;
        if (this._addedTimer) clearTimeout(this._addedTimer);
        const original = label.dataset.label || label.textContent.trim();
        const addedText = label.dataset.addedLabel || "Added";
        label.textContent = "✓ " + addedText;
        this.submitButton.classList.add("is-added");
        this._addedTimer = setTimeout(() => {
          label.textContent = original;
          this.submitButton.classList.remove("is-added");
          this._addedTimer = null;
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
